<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <router-link
                class="btn btn-outline-primary btn-sm mr-3"
                :to="{ name: 'all-services-cn' }"
                ><i class="fa fa-chevron-left mr-2"></i
                >{{ $t("message.back") }}</router-link
              >
              <h4 class="card-title">
                {{ $t("message.find_partner.corporate_news_search") }}
              </h4>
            </div>
            <pdf
              v-if="searchComplete"
              :user_id="0"
              :document="response_info"
              :doc_additional="{ request: keyWord }"
              :goods="[]"
              :doc_id="0"
              source="corporate_news_service-cn"
            ></pdf>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <br />
                <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                  <input
                    type="text"
                    class="form-control"
                    id="keyword"
                    v-model="keyWord"
                    :placeholder="$t('message.find_partner.search_keyword')"
                    autocomplete="off"
                    style="cursor: auto"
                  />
                  <label for="keyword" class="form-label-group-label">{{
                    $t("message.find_partner.search_keyword")
                  }}</label>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <button
                  :class="[
                    'btn',
                    'btn-success',
                    'btn-round',
                    'btn-sm',
                    'position-relative',
                  ]"
                  @click="searchCompanyCourtInfo"
                  id="init_search_china"
                >
                  {{ $t("message.find_partner.search_button") }}
                </button>
              </div>
            </div>
            <br />

            <div
              v-if="!searchComplete && loading"
              style="position: relative; height: 100px"
            >
              <div class="loading"></div>
            </div>

            <div v-if="searchComplete">
              <div v-if="response_info.length > 0">
                <div
                  class="card-header card-header-primary negative blue-grad rounded-0 w-50"
                >
                  <h4>
                    {{ $t("message.find_partner.corporate_news_search") }}
                  </h4>
                </div>
                <br />
                <b-table
                  :fields="corporate_search_list_fields"
                  :items="response_info"
                  :responsive="true"
                >
                </b-table>
              </div>
            </div>
            <div v-if="searchComplete && no_result" class="p-3 text-center">
              {{
                $t("message.find_partner.no_results").replace(
                  "[company]",
                  keyWord,
                )
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      no_result: false,
      current_tab: 0,
      response_info: [],
      service_info: {},
      service_info_objects: {},
      keyWord: "",
      searchComplete: false,
      corporate_search_list_fields: [
        {
          key: "Id",
          label: this.$t("message.find_partner.corporate_news_search_Id"),
        },
        {
          key: "NewsId",
          label: this.$t("message.find_partner.corporate_news_search_NewsId"),
        },
        {
          key: "Source",
          label: this.$t("message.find_partner.corporate_news_search_Source"),
        },
        {
          key: "Title",
          label: this.$t("message.find_partner.corporate_news_search_Title"),
        },
        {
          key: "Url",
          label: this.$t("message.find_partner.corporate_news_search_Url"),
        },
        {
          key: "PublishTime",
          label: this.$t(
            "message.find_partner.corporate_news_search_PublishTime",
          ),
        },
        {
          key: "EmotionType",
          label: this.$t(
            "message.find_partner.corporate_news_search_EmotionType",
          ),
        },
        {
          key: "Category",
          label: this.$t("message.find_partner.corporate_news_search_Category"),
        },
        {
          key: "NewsTags",
          label: this.$t("message.find_partner.corporate_news_search_NewsTags"),
        },
        {
          key: "Content",
          label: this.$t("message.find_partner.corporate_news_search_Content"),
        },
      ],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    translateTextArray(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
            "/library/TranslateNextArray?source=zh&target=" +
            locale,
          text,
        );
      }
    },
    formatArrayObjectTables(object, list) {
      if (object.length > 0) {
        object.forEach((obj, i) => {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          this.translateTextArray(values).then((res) => {
            var translated = {};
            for (let j = 0; j < res.data.length; j++) {
              translated[keys[j]] = JSON.parse(res.data[j]).translation;
              console.log("translated");
              console.log(translated);
            }
            list.push(translated);
          });
        });
      }
    },
    searchCompanyCourtInfo() {
      axios
        .get(window.base + "/admin/GetBillingServiceInfo?code=701")
        .then((response) => {
          this.$bvModal
            .msgBoxConfirm(
              this.$t("message.find_partner.cn_company_info_check_alert") +
                " " +
                response.data.billing_service_price +
                " " +
                response.data.billing_service_cur,
              {
                title: this.$t("message.confirm"),
                size: "md",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: this.$t("message.yes"),
                cancelTitle: this.$t("message.no"),
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              },
            )
            .then((value) => {
              if (value) {
                this.loading = true;
                this.searchComplete = false;
                axios
                  .get(
                    "https://attistrade.cn/library/openAPINews?keyWord=" +
                      this.keyWord,
                  )
                  .then((response) => {
                    if (response.data.Result.length > 0) {
                      this.formatArrayObjectTables(
                        response.data.Result,
                        this.response_info,
                      );
                      this.no_result = false;
                    } else {
                      this.no_result = true;
                    }
                    this.searchComplete = true;
                    this.loading = false;
                  })
                  .catch(() => {
                    this.searchComplete = true;
                    this.loading = false;
                    this.no_result = true;
                    //{"Status":"201","Message":"【有效请求】查询无结果","OrderNumber":"COMPANYNEWS2022101117341841065834","Paging":null,"GroupItems":null,"Result":null}
                  });
              }
            });
        });
    },
  },
};
</script>
